$(".foter__menu-block h3").on("click", function () {
  $(this).closest(".foter__menu-block ").find("ul").slideToggle();
  $(this).toggleClass("active");
});

$(document).ready(function () {
  if (!window.location.href.includes(".com/search")) {
    setCookie("prevpage", window.location.href, 1);
  }

  $(".toggle_sub").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).closest("li").find("ul").slideToggle();
  });

  $(".toggle_sub").parent("li").on("click", function (e) {

   if ($(e.target).hasClass("toggleParent")) { 
      e.preventDefault();
      
      $(this).find(".toggle_sub").toggleClass("active");
      $(this).find("ul").slideToggle();
    }
 
});
  
  $(".mobile_menu-localization").on("click", function (e) {
    e.preventDefault();
    if ($(".disclosure__button").attr("aria-expanded") == "false") {
      $(".disclosure__list-wrapper").removeAttr("hidden");
      $(".disclosure__button").attr("aria-expanded", "true");
    } else {
      $(".disclosure__list-wrapper").attr("hidden", "true");
      $(".disclosure__button").attr("aria-expanded", "false");
    }

    return false;
  });

  $(".mobile-facets__main .filter_sliding a.toggle").on("click", function (e) {
    e.preventDefault();
    $(this).closest(".filter_sliding--item").toggleClass("open");
    $(this).parent("div").find(".filter_sliding--item-child").slideToggle();
  });

  $(document).on("click", ".label_block", function () {
    $(this).toggleClass("filter_open");
    $(this).parent("div").find(".facet_filter_container").slideToggle();
  });

  $(".mobile-facets__list-color li").mouseover(function () {
    let color = $(this).find("input").val();
    $(this).closest(".mobile-facets__details").find(".color_hover").html(color);
  });

  $(".mobile-facets__list-color li").mouseout(function () {
    $(this).closest(".mobile-facets__details").find(".color_hover").html("");
  });
});
